import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './AlternateItemsEntity.g';

function getAttributeInfoQuery(): DataServiceQuery {
    return new DataServiceQuery();
    }


export function getAtrributeInfoInput (
  attributeName:
      string
): IDataServiceRequest {
const query = getAttributeInfoQuery();
return query.createDataServiceRequestForOperation(
    'GetAttributeInfo',
    true,
      DataServiceEntities.GCGetAttributeInfoResponseExtensionClass
    ,
    'false',
    { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGCGetAttributeInfoResponse' },
    {
      attributeName: attributeName
    }
);
}

export function getAttributeInfoAsync (
  context: IContext, attributeName: string
  ): AsyncResult<DataServiceEntities.IGCGetAttributeInfoResponse> {
  const request = getAtrributeInfoInput(attributeName);
  return callActionOrExecute<DataServiceEntities.IGCGetAttributeInfoResponse>(request, context.callerContext);
  }
